<p>payment-redirection works!</p>
